import {h, Fragment} from "preact"
import { RangeSlider, useRangeSlider, useFacet } from "@nosto/preact"
import { useState, useEffect } from "preact/hooks"
import RangeInput from "./elements/RangeInput"
import Checkbox from "./elements/Checkbox"

export default function RangeFacet({ facet }) {
    const { min, max, range, updateRange } = useRangeSlider(facet.id)
    const isSelected = min !== range[0] || max !== range[1]
    const [active, setActive] = useState(false)
    const [selectedRanges, setSelectedRanges] = useState([])
    const settings = window.plpSettings || {}
    const isSizeFacet = facet.name.toLowerCase().includes('size')

    useEffect(() => {
        const isDesktop = window.matchMedia("(min-width: 768px)").matches
        if (isDesktop && !active) {
            setActive(true)
        }
    }, []) 
    
    const priceRanges = [
        { label: `${settings.currency_symbol}0 - ${settings.currency_symbol}${Math.ceil(50 * Shopify.currency.rate)}`, min: 0, max: 50, value: "0-50" },
        { label: `${settings.currency_symbol}${Math.ceil(50 * Shopify.currency.rate)} - ${settings.currency_symbol}${Math.ceil(100 * Shopify.currency.rate)}`, min: 50, max: 100, value: "50-100" },
        { label: `${settings.currency_symbol}${Math.ceil(100 * Shopify.currency.rate)} - ${settings.currency_symbol}${Math.ceil(200 * Shopify.currency.rate)}`, min: 100, max: 200, value: "100-200" },
        { label: `${settings.currency_symbol}${Math.ceil(200 * Shopify.currency.rate)} +`, min: 200, max: max, value: `200-${max}` },
    ]

    const getSelectedMinMaxFromList = (list) => {
        const selected = priceRanges.filter(pr => list.includes(pr.value))
        const selectedMin = Math.min(...selected.map(pr => pr.min))
        const selectedMax = Math.max(...selected.map(pr => pr.max))
        return [selectedMin, selectedMax]
    }

    const toggleRange = (rangeObj) => {
        setSelectedRanges(prev => {
            const exists = prev.includes(rangeObj.value)
            const updated = exists
                ? prev.filter(v => v !== rangeObj.value)
                : [...prev, rangeObj.value]

            const [newMin, newMax] = updated.length > 0
                ? getSelectedMinMaxFromList(updated)
                : [min, max]

            updateRange([newMin, newMax])
            // Scroll to top
            //window.scrollTo({ top: 0, behavior: 'smooth' })
            return updated
        })
    }

    // On initial load, check if selected range matches any preset ranges
    useEffect(() => {
        if (!isSelected) return
    
        const strictlyInside = priceRanges
            .filter(pr => pr.min >= range[0] && pr.max <= range[1])
            .map(pr => pr.value)
    
        setSelectedRanges(strictlyInside)
    }, [])

    return (
        <li class={`ns-sidebar-dropdown border-b border-solid color-border-dark ${active ? "ns-active" : ""}`} aria-expanded={!!active}>
            <span
                id={facet.name}
                class="ns-anchor ns-d-inline-block ns-relative ns-w-100 ns-border-box"
                onClick={() => setActive(!active)}
                aria-controls={`${facet.id}-sub-menu`}
                aria-label={`${active ? 'Collapse' : 'Expand'} ${facet.name}`}
            >
                <span class="color-text text-[18px]">{facet.name}</span>
                {active ? (
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none" style={{ verticalAlign: 'middle', marginLeft: '8px' }}>
                        <path d="M18 12.5H6" stroke="#191919" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none" style={{ verticalAlign: 'middle', marginLeft: '8px' }}>
                        <path d="M12 6.21875V12.2188M12 12.2188V18.2188M12 12.2188H18M12 12.2188L6 12.2187" stroke="#191919" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                )}
            </span>
            <div class={`ns-sidebar-submenu ${active ? '' : 'ns-d-none'}`} id={`${facet.id}-sub-menu`}>
                <ul className="ns-list-unstyled ns-p-0 ns-m-0" role="menu">
                    {priceRanges.map(rangeObj => (
                        <li
                            key={rangeObj.value}
                            className="ns-d-flex ns-align-items-center ns-font-3 ns-py-2"
                            data-nosto-element="facet-setting"
                            role="menuitem"
                        >
                            <Checkbox
                                value={rangeObj.label}
                                min={rangeObj.min}
                                max={rangeObj.max}
                                selected={selectedRanges.includes(rangeObj.value)}
                                onChange={() => toggleRange(rangeObj)}
                            />
                        </li>
                    ))}
                </ul>
            </div>
        </li>
    )
}